import { render, staticRenderFns } from "./setContactDialog.vue?vue&type=template&id=9d54b7d2&scoped=true&"
import script from "./setContactDialog.vue?vue&type=script&lang=js&"
export * from "./setContactDialog.vue?vue&type=script&lang=js&"
import style0 from "./setContactDialog.vue?vue&type=style&index=0&id=9d54b7d2&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9d54b7d2",
  null
  
)

export default component.exports